const STYLES = {
  Placed: "bg-[#EFF6FF] text-[#1D4ED8]",
  Shipped: "bg-[#FEF3C7] text-[#B45309]",
  Delivered: "bg-[#DCFCE7] text-[#15803D]",
};

export const StatusBadge = ({ status, testId }) => (
  <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold ${STYLES[status] || "bg-slate-100 text-slate-600"}`} data-testid={testId}>
    {status}
  </span>
);
